import { createRouter, createWebHistory } from 'vue-router'

/**
 * Routes exist so deep links survive: the prototypes lean on `?tab=`,
 * `?task=`, `?find=` and friends, and those become real URLs here. The tabs
 * themselves are not built yet — see docs/prototypes/README.md.
 */
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/HomeView.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/',
    },
  ],
})

export default router
